export { default } from './VerifiedAtlantmLanding';
